import { Form, Select } from 'antd';
import React from 'react';

const AppSelect = React.forwardRef(
  (
    {
      items,
      onChange,
      onSearch,
      defaultValue,
      placeholder = 'Select package',
      title = 'Filter',
      value,
      label,
      formItemClassName = '',
      ...props
    },
    ref
  ) => {
    return (
      <Form.Item label={label} className={`${formItemClassName}`}>
        <Select
          ref={ref}
          options={items}
          onChange={onChange}
          onSearch={onSearch}
          placeholder={placeholder}
          showSearch
          defaultValue={defaultValue}
          optionFilterProp="label"
          title={title}
          value={value}
          className="w-full"
          {...props}
        />
      </Form.Item>
    );
  }
);

AppSelect.displayName = 'AppSelect';

export default AppSelect;
